import CourseCreatePage from "./courseCreatePage"
export default CourseCreatePage;